import React from "react";
import TextMedium from "../TextComponent/TextMedium";
import convertUnicodeEmoji from "../../../actions/convertUnicodeEmoji";
import TimeCounterMinute from "../../../containers/TimeCounterMinute";
import {
  SolicitarChamada,
  InterationNotifier,
  GetHistory,
  CarregamentoInteractions,
  ShowInfoDisplay,
  ActionRefreshNoAnswer,
  DetailsAnotationsida,
  DetailsFileShared,
  DetailsMarkstarida,
  InteracoesContactNumber,
  GetInteractionsModal,
} from "../../../actions";
import { RefreshNoAnswerCall } from "../../../actions/websocket";
import { useDispatch, useSelector } from "react-redux";
import MicroModal from "micromodal";
import Moment from "moment";

import { ReactComponent as IconQueueTime } from "../../../build/images/iconqueuetime.svg";
import { ReactComponent as MessengerIcon } from "../../../build/images/icons-channels/messenger.svg";
import { ReactComponent as WhatsappIcon } from "../../../build/images/icons-channels/whatsapp.svg";
import { ReactComponent as WhatsappVoiceIcon } from "../../../build/images/whatsapp_voice.svg";
import { ReactComponent as FacebookIcon } from "../../../build/images/icons-channels/facebook.svg";

import { ReactComponent as InstagramIcon } from "../../../build/images/icons-channels/instagram.svg";
import { ReactComponent as TelegramIcon } from "../../../build/images/icons-channels/telegram.svg";

import { ReactComponent as VozIcon } from "../../../build/images/icons-channels/voz.svg";
import { ReactComponent as EmailIcon } from "../../../build/images/icons-channels/email.svg";
import { ReactComponent as WebchatIcon } from "../../../build/images/icons-channels/webchat.svg";
import { ReactComponent as ClockIcon } from "../../../build/images/clockicon.svg";
import { ReactComponent as ProfileIcon } from "../../../build/images/profiletwo.svg";
import { ReactComponent as TimeIcon } from "../../../build/images/icontime.svg";
import { ReactComponent as MoreIcon } from "../../../build/images/moreinfo.svg";
import { ReactComponent as CircleIcon } from "../../../build/images/infocircle.svg";
import { ReactComponent as BadIcon } from "../../../build/images/evaluationbad.svg";
import { ReactComponent as CallIcon } from "../../../build/images/iconcallmanager.svg";
import { ReactComponent as CallIconWhite } from "../../../build/images/iconcallmanagerwhite.svg";
import { ReactComponent as CallIconBlue } from "../../../build/images/iconcallmanagerblue.svg";
import { ReactComponent as AlertIcon } from "../../../build/images/iconalertmanager.svg";
import { ReactComponent as TimeIconManager } from "../../../build/images/icontimemanager.svg";
import { ReactComponent as EmptyState } from "../../../build/images/emptystatemanagerhorizontal.svg";
import { Popover } from "../../../actions/Tippy";
import AnotationModal from "../../modals/AnotationModal";
import FileShareModal from "../../modals/FileShareModal";
import MessageFavoriteModal from "../../modals/MessageFavoriteModal";
import DeleteCallModal from "../../modals/DeleteCallModal";
import HistoricCallModal from "../../modals/HistoricCallModal";
import ModalsDetails from "../../modals/NewModals/index";

export default function CardQueue({
  title,
  queue,
  timeOfAverage,
  clientQueueMax,
  qtdQueue,
  width,
  classname = "",
}) {
  const dispatch = useDispatch();
  const StatusAgent = useSelector((state) => state.status);
  const InfoUsers = useSelector((state) => state.informationusers);

  const renderPopoverAction = (e, infousers) => (
    <div className="context-menu" id="info-fila">
      <ul className="context-menu__list">
        {(() => {
          if (infousers.supervisor === true) {
            return (
              <>
                {" "}
                <li className="context-menu__item">
                  <a
                    className="context-menu__link"
                    onClick={() =>
                      RefreshNoAnswer(
                        clientQueueMax[0].queueCdrid,
                        clientQueueMax[0].queueQueueid,
                        InfoUsers,
                      )
                    }
                  >
                    Atualizar para não atendida
                  </a>
                </li>
              </>
            );
          }
        })()}
      </ul>
    </div>
  );

  const RefreshNoAnswer = () => {
    dispatch(ActionRefreshNoAnswer(clientQueueMax[0].queueQueueid));
    RefreshNoAnswerCall(
      clientQueueMax[0].queueCdrid,
      clientQueueMax[0].queueQueueid,
      InfoUsers,
    );
    document.getElementById("simulation_click").click();
  };

  const ShowModals = (
    e,
    numberqueue,
    contactname,
    modal,
    cdrid,
    queueid,
    queue,
    infousers,
  ) => {
    // this.ShowNameCli(numberqueue, contactname);

    //Função que seta o nome e o número do contato pros modais

    dispatch(GetInteractionsModal(contactname, numberqueue));

    //
    switch (modal) {
      case "modal__anotacoes":
        buttonSearchAnotation();
        MicroModal.show("modal__anotacoes-details-new");
        break;
      case "modal__arquivos-compartilhados_manager":
        buttonSearchFileCompart();
        MicroModal.show("modal__arquivos-compartilhados-details");
        break;
      case "modal__mensagens-favoritas":
        buttonSearchMarkstar();
        MicroModal.show("modal__mensagens-favoritas-details");
        break;
      case "modal__historico-atendimento_manager":
        // this.props.ClearHistory();
        // dispatch(GetHistory([]));
        // let histstart = this.datahistoryinitmanager.value;
        // let histend = this.datahistoryfimmanager.value;
        // if (queue.status === "1") {
        //   this.props.CarregamentoInteractions(cdrid);
        // } else {
        //   this.props.CarregamentoCDR(queueid);
        // }
        // dispatch(
        //   CarregamentoInteractions(
        //     clientQueueMax[0].queueCdrid,
        //     infousers.idgroup
        //   )
        // );
        DisplayHistoric(numberqueue, contactname);

        MicroModal.show("modal__historico-atendimento-details");
        // this.setState({clientpdf: numberqueue, datapdfend: histend, datapdfinit: histend, cliente: contactname})
        break;
      case "modal__excluir":
        MicroModal.show("modal__excluir_manager_new");
        break;
      default:
        break;
    }
  };

  const renderPopoverInfo = (
    e,
    numberqueue,
    contactname,
    cdrid,
    queueid,
    queue,
    infousers,
  ) => (
    <div className="context-menu" id="info-fila">
      <ul className="context-menu__list">
        <li className="context-menu__item">
          <a
            onClick={(event) =>
              ShowModals(
                e,
                numberqueue,
                contactname,
                "modal__anotacoes",
                cdrid,
                queueid,
                queue,
                infousers,
              )
            }
            className="context-menu__link"
          >
            Anotações
          </a>
        </li>
        <li className="context-menu__item">
          <a
            onClick={(event) =>
              ShowModals(
                event,
                numberqueue,
                contactname,
                "modal__arquivos-compartilhados_manager",
                cdrid,
                queueid,
                queue,
                infousers,
              )
            }
            className="context-menu__link"
          >
            Arquivos compartilhados
          </a>
        </li>
        <li className="context-menu__item">
          <a
            onClick={(event) =>
              ShowModals(
                event,
                numberqueue,
                contactname,
                "modal__mensagens-favoritas",
                cdrid,
                queueid,
                queue,
                infousers,
              )
            }
            className="context-menu__link"
          >
            Mensagens favoritas
          </a>
        </li>
        <li className="context-menu__item">
          <a
            onClick={(event) =>
              ShowModals(
                e,
                numberqueue,
                contactname,
                "modal__historico-atendimento_manager",
                cdrid,
                queueid,
                queue,
                infousers,
              )
            }
            className="context-menu__link"
          >
            Interações
          </a>
        </li>
      </ul>
    </div>
  );

  const answerCallQueue = (scriptid, cdrid, mediaid) => {
    if (StatusAgent.allowCapture === false) {
      dispatch(InterationNotifier("Pausa não permite captura", "permission"));
    } else {
      dispatch(
        SolicitarChamada(
          InfoUsers,
          scriptid,
          cdrid,
          mediaid,
          StatusAgent.status,
          StatusAgent,
        ),
      );
      dispatch(ShowInfoDisplay("Clientes"));
    }
  };

  const buttonSearchAnotation = (e, telefone) => {
    var erro = 0;
    let now = Moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = Moment().format("YYYY-MM-DD");
    const idcriticidade = "";

    let comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      dispatch(
        DetailsAnotationsida(
          datainit,
          datafim,
          idcriticidade,
          clientQueueMax[0].queueCaller,
        ),
      );
    }
  };

  const buttonSearchFileCompart = (e, telefone) => {
    var erro = 0;
    let now = Moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = Moment().format("YYYY-MM-DD");
    const formats =
      "3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28";
    const midias = "2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18";
    // const formats = this.mimetypeids.value;
    // const midias = this.midias.value;

    var comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (formats == "") var erro = 1;

    if (midias == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      dispatch(
        DetailsFileShared(
          datainit,
          datafim,
          formats,
          midias,
          clientQueueMax[0].queueCaller,
        ),
      );
    }
  };

  const buttonSearchMarkstar = (e, telefone) => {
    var erro = 0;
    let now = Moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = Moment().format("YYYY-MM-DD");

    var comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      dispatch(
        DetailsMarkstarida(datainit, datafim, clientQueueMax[0].queueCaller),
      );
    }
  };

  const DisplayHistoric = (telefone, contactname, cdrid) => {
    let now = Moment().subtract(7, "days");
    const histstart = now.format("YYYY-MM-DD") + "T00:00";
    const histend = Moment().format("YYYY-MM-DD") + "T23:59";
    let idgroup = InfoUsers.idgroup;

    dispatch(
      InteracoesContactNumber(
        clientQueueMax[0].queueCaller,
        histstart,
        histend,
        "",
        idgroup,
      ),
    );
  };

  return (
    <div
      className={
        width === "small"
          ? `manager-component__card-queue small ${classname}`
          : `manager-component__card-queue ${classname}`
      }
    >
      <div className="manager-component__card-queue__icon">
        {queue === "time-queue" && (
          <div className="manager-component__card-queue__icon__title">
            <ClockIcon />
            <TextMedium text={title} color="gray" />
          </div>
        )}
        {queue === "client-queue" && (
          <div className="manager-component__card-queue__icon__title">
            <ProfileIcon />
            <TextMedium text={title} color="gray" />
            <span className="manager-component__card-queue__title_qtd">
              ({qtdQueue})
            </span>
          </div>
        )}
        {queue === "client-queue" && (
          <div className="manager-component__card-queue__title-itens">
            {clientQueueMax.length !== 0 && (
              <>
                <div
                  className="manager-component__card-queue__title-button"
                  onClick={() =>
                    answerCallQueue(
                      clientQueueMax[0].queueScriptid,
                      clientQueueMax[0].queueCdrid,
                      clientQueueMax[0].queueMediaid,
                    )
                  }
                >
                  <CallIconBlue />
                  <span className="manager-component__card-queue__title-text">
                    Atender Chamada
                  </span>
                </div>
                <Popover
                  trigger="click"
                  boundary="window"
                  placement="right"
                  multiple={true}
                  interactive={true}
                  content={renderPopoverInfo(
                    this,
                    clientQueueMax[0].queueCaller,
                    clientQueueMax[0].queueContactname,
                    clientQueueMax[0].queueCdrid,
                    clientQueueMax[0].queueQueueid,
                    clientQueueMax[0].queueGeral,
                    InfoUsers,
                  )}
                >
                  <li>
                    <CircleIcon />
                  </li>
                </Popover>
                <Popover
                  trigger="click"
                  boundary="window"
                  placement="right"
                  multiple={true}
                  interactive={true}
                  content={renderPopoverAction(this, InfoUsers)}
                >
                  <li>
                    <MoreIcon />
                  </li>
                </Popover>
              </>
            )}
          </div>
        )}
      </div>
      {queue === "time-queue" ? (
        <div
          className={
            width === "small"
              ? "manager-component__card-queue__box-contents small"
              : "manager-component__card-queue__box-contents-queue"
          }
        >
          {timeOfAverage.map((queue, index) => (
            <>
              <div className="manager-component__card-queue__box-contents__itens">
                <div className="manager-component__card-queue__box-contents__itens-icon">
                  <TimeIcon />
                </div>
                <div className="manager-component__card-queue__box-contents__itens-text">
                  <h3>{queue.time}</h3>
                  <span>
                    {width === "small" ? queue.titleSmall : queue.title}
                  </span>
                </div>
              </div>
            </>
          ))}
        </div>
      ) : (
        <>
          {clientQueueMax.length !== 0 ? (
            <div className="manager-component__card-queue__box-contents-two">
              {/* <div className="manager-component__card-queue__box-contents-two_title">
                        <span>Cliente com o maior tempo em fila:</span>
                    </div> */}
              <div className="manager-component__card-queue__box-contents-itens">
                <div className="manager-component__card-queue__box-contents-itens__box-icon">
                  <IconQueueTime />
                  <div className="manager-component__card-queue__box-contents-itens__box-icon-media">
                    {clientQueueMax[0].queueMediaid === 1 && <VozIcon />}
                    {clientQueueMax[0].queueMediaid === 2 && <WebchatIcon />}
                    {clientQueueMax[0].queueMediaid === 3 && <EmailIcon />}
                    {clientQueueMax[0].queueMediaid === 4 && <FacebookIcon />}
                    {clientQueueMax[0].queueMediaid === 5 && <WhatsappIcon />}
                    {clientQueueMax[0].queueMediaid === 6 && <InstagramIcon />}
                    {clientQueueMax[0].queueMediaid === 8 && <TelegramIcon />}
                    {clientQueueMax[0].queueMediaid === 16 && (
                      <WhatsappVoiceIcon width="36" height="36" />
                    )}
                  </div>
                </div>
                <div>
                  <span>
                    {clientQueueMax[0].queueContactname !== " "
                      ? convertUnicodeEmoji(clientQueueMax[0].queueContactname)
                      : clientQueueMax[0].queueCaller}
                  </span>
                  {/* <li>
                                <BadIcon /><p>Cliente insatisfeito</p>
                            </li> */}
                  <div className="manager-component__card-queue__box-contents-itens__card">
                    <div className="manager-component__card-queue__box-contents-itens__card-item">
                      <li>
                        <CallIcon />
                        <span>{clientQueueMax[0].queueCaller}</span>
                      </li>
                      <li>
                        <AlertIcon />
                        <span>{clientQueueMax[0].queueCalled}</span>
                      </li>
                    </div>
                    <div className="manager-component__card-queue__box-contents-itens__card-item">
                      <li>
                        <TimeIconManager />
                        <span>
                          <TimeCounterMinute
                            horario={
                              clientQueueMax[0].queueDurationQueue < 0
                                ? 0
                                : parseInt(clientQueueMax[0].queueDurationQueue)
                            }
                            key={clientQueueMax[0].queueQueueid}
                          />
                        </span>
                      </li>
                      <li>
                        <span>
                          Qtd. de tentativas: (
                          {clientQueueMax[0].queueRecv_count})
                        </span>
                      </li>
                    </div>
                    <div className="manager-component__card-queue__box-contents-itens__card-item">
                      <li>
                        <span>
                          Qtd. de retornos: (
                          {clientQueueMax[0].queueCallback_count})
                        </span>
                      </li>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="manager-component__card-queue__box-contents-action">
                        <button
                           onClick={() => answerCallQueue(clientQueueMax[0].queueScriptid,clientQueueMax[0].queueCdrid,clientQueueMax[0].queueMediaid)}
                        >
                            <CallIconWhite />
                            Atender Chamada
                        </button>
                    </div> */}
            </div>
          ) : (
            <div className="manager-component__card-queue__box-empty">
              <div className="manager_empty-state__card_queue">
                <EmptyState />
              </div>
            </div>
          )}
          <ModalsDetails.NewAnotationModal
            ContactId={{
              cliente:
                clientQueueMax.length !== 0
                  ? clientQueueMax[0].queueContactname !== " "
                    ? clientQueueMax[0].queueContactname
                    : clientQueueMax[0].queueCaller
                  : "",
              telefone:
                clientQueueMax.length !== 0
                  ? clientQueueMax[0].queueCaller
                  : "",
            }}
          />
          {/* <AnotationModal 
                    clientQueueMax={clientQueueMax} 
                /> */}

          <ModalsDetails.NewFileShareModal
            ContactId={{
              cliente:
                clientQueueMax.length !== 0
                  ? clientQueueMax[0].queueContactname !== " "
                    ? clientQueueMax[0].queueContactname
                    : clientQueueMax[0].queueCaller
                  : "",
              telefone:
                clientQueueMax.length !== 0
                  ? clientQueueMax[0].queueCaller
                  : "",
            }}
          />

          {/* <FileShareModal 
                    clientQueueMax={clientQueueMax} 
                /> */}

          <ModalsDetails.NewMessageFavoriteModal
            ContactId={{
              cliente:
                clientQueueMax.length !== 0
                  ? clientQueueMax[0].queueContactname !== " "
                    ? clientQueueMax[0].queueContactname
                    : clientQueueMax[0].queueCaller
                  : "",
              telefone:
                clientQueueMax.length !== 0
                  ? clientQueueMax[0].queueCaller
                  : "",
            }}
          />
          {/* <MessageFavoriteModal 
                    clientQueueMax={clientQueueMax} 
                /> */}
          {/* <DeleteCallModal 
                    clientQueueMax={clientQueueMax} 
                /> */}

          {/* <HistoricCallModal 
                    clientQueueMax={clientQueueMax} 
                /> */}
        </>
      )}
      <input type="hidden" id="simulation_click" name="simulation_click" />
    </div>
  );
}
